<template>
	<div class="psi">
		<!-- 诊所描述Card -->
		<div class="inCard">
			
		</div>
		
		<div class="shop-header">
			<!-- <span>诊所管理</span> -->
			
		</div>
		
		<!-- 测试高度 -->
		<StagTable></StagTable>
		
	</div>
</template>

<script>
	// selfs / sons

	import StagTable from '../../external/comment/StagTable.vue'
	export default {
		components: {
			StagTable
		},
		data() {
			return {

			}
		},

		methods: {



		},

		//生命周期
		created() {
			
		},

	}
</script>

<style lang="less" scoped>
.psi{
	height: 100%;
	width: 100%;

}
</style>